"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBarExampleCodeSegments = exports.ProgressBarExample = void 0;
var React = __importStar(require("react"));
var GKProgressBar_1 = require("@granular/gds-ux-components/lib/components/GKProgressBar/GKProgressBar");
var ProgressBarExample = function () {
    var _a = React.useState(0), value = _a[0], setValue = _a[1];
    var tick = function () {
        setValue(function (currentValue) {
            if (currentValue === 100) {
                return 0;
            }
            else {
                return Math.min(currentValue + Math.floor(Math.random() * 12), 100);
            }
        });
    };
    React.useEffect(function () {
        var timerId = window.setInterval(tick, 250);
        return function () { return window.clearInterval(timerId); };
    }, []);
    return (React.createElement("div", null,
        React.createElement("h3", null, "Determinate"),
        React.createElement(DoubledBars, { width: 500, value: value }),
        React.createElement("br", null),
        React.createElement("h3", null, "Indeterminate"),
        React.createElement(DoubledBars, { width: 500 })));
};
exports.ProgressBarExample = ProgressBarExample;
var DoubledBars = function (props) {
    return (React.createElement("div", null,
        React.createElement("div", { className: "p-2 m-1 d-inline-block" },
            React.createElement(GKProgressBar_1.GKProgressBar, __assign({}, props)),
            React.createElement(PercentageIndicator, { val: props.value })),
        React.createElement("br", null),
        React.createElement("div", { className: "bg-dark m-1 p-2 d-inline-block" },
            React.createElement(GKProgressBar_1.GKProgressBar, __assign({}, props, { inverse: true })),
            React.createElement(PercentageIndicator, { val: props.value }))));
};
var PercentageIndicator = function (_a) {
    var val = _a.val;
    return val !== undefined ? React.createElement("span", { className: "px-2 " },
        val,
        "%") : null;
};
// AUTOGENERATED:
/* eslint-disable prettier/prettier */
exports.ProgressBarExampleCodeSegments = [""];
/* eslint-enable prettier/prettier */
